import { Link } from "react-router-dom";
import React, { useState, useCallback, useContext, useEffect } from "react";
import { ChangePassword } from "../Service/Auth-Services";
import * as Yup from "yup";
import { useFormik } from "formik";
import LoginLoader from "../../../Shared/Sidebar/LoginLoader";
import { GetMasterSystemAlert } from "../../../Services/Global-Services/GlobalServices";
import { TostMsg } from "../../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const SetPassword = () => {
  const [loader, setLoader] = useState(false);
  const [changePasswordDesc, setChangePasswordDesc] = useState("");
  const [successPasswordChange, setSuccessPasswordChange] = useState("");
  const [newPasswordRequired, setNewPasswordRequired] = useState([]);
  const [confirmPasswordRequired, setConfirmPasswordRequired] = useState([]);
  const [passwordMatched, setPasswordMatched] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  let history = useHistory();
  let accessToken = JSON.parse(localStorage.getItem("Authentication") || "{}");
  const toster = useContext(TostMsg);

  function ViewPassword() {
    let pwd = document.getElementById("viewPassword");
    if (pwd.type === "password") {
      pwd.type = "text";
    } else {
      pwd.type = "password";
    }
  }

  useEffect(() => {
    GetMasterSystemAlertList();
  }, []);

  function ViewPasswords() {
    let pwds = document.getElementById("viewPassword");
    if (pwds.type === "password") {
      pwds.type = "text";
    } else {
      pwds.type = "password";
    }
  }

  function ViewPasswords() {
    let pwds = document.getElementById("viewPasswords");
    if (pwds.type === "password") {
      pwds.type = "text";
    } else {
      pwds.type = "password";
    }
  }
  const ChangePasswordValidation = Yup.object().shape({
    newPassword: Yup.string()
      .required(`${newPasswordRequired}`)
      .min(8, "Password must be at least 8 characters"),
    confirmPassword: Yup.string()
      .required(`${confirmPasswordRequired}`)
      .oneOf([Yup.ref("newPassword"), null], passwordMatched),
  });

 const ChangePasswordsForm = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: ChangePasswordValidation,
    onSubmit: (data) => {
      setFormData(data);
      setShowModal(true); 
    },
  });

  const handleChangePassword = async () => {
    if (!formData) return;
    setLoader(true);
    const params = {
      newPassword: formData.newPassword,
      confirmPassword: formData.confirmPassword,
      AcessToken: accessToken?.access_token,
    };
    try {
      let ChangeInPassword = await ChangePassword(params);
      if (ChangeInPassword.StatusCode === 2000) {
        toster.current.success(successPasswordChange);
        setTimeout(() => {
          history.push("/LoginByPassword");
        }, 1000);
      }
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setLoader(false);
      setShowModal(false);
    }
  };

  const GetMasterSystemAlertList = useCallback(async () => {
    const body = {
      Name: "",
    };
    try {
      let MasterSystemAlert = await GetMasterSystemAlert(body);
      localStorage?.setItem(
        "SystemAlerts",
        JSON?.stringify(MasterSystemAlert?.Data)
      );
      MasterSystemAlert?.Data?.filter((msg) => {
        if (msg?.Name == "Reset_Password_Message") {
          setSuccessPasswordChange(msg?.Desc);
        } else if (msg?.Name == "Set_Password") {
          setChangePasswordDesc(msg?.Desc);
        } else if (msg?.Name == "New_Password_Required") {
          setNewPasswordRequired(msg?.Desc);
        } else if (msg?.Name == "Confirm_Password_For_New") {
          setConfirmPasswordRequired(msg?.Desc);
        } else if (msg?.Name == "password_Not_Match") {
          setPasswordMatched(msg?.Desc);
        }
      });
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setLoader(false);
    }
  }, []);

  return (
    <div style={{ minHeight: "auto" }}>
      <img src="images/org-img/sideimg.png" className="chngpassword-img" />
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <img src="images/org-img/password.png" style={{ width: "17%" }} />
              <h2 className="me-h2 font-w600 mb-0">
                <b className="resetfont" style={{ marginRight: "10px" }}>
                  Set{" "}
                </b>{" "}
                Password
              </h2>
              <p className="text-light">{changePasswordDesc}</p>
            </div>
          </div>
          <div className="">
            <div className="row card-radius">
              <form onSubmit={ChangePasswordsForm.handleSubmit}>
                <div className="chng-word">
                  <div className="d-flex">
                    <div className="left1">
                      <div className="current-user">
                        <div className="">
                          <img
                            className="avatar is-squared w-100"
                            src="images/org-img/reset.svg"
                            data-demo-src="images/avatar/5.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div className="center1">
                      <div className="form-group mb-4">
                        <h4 className="block-heading mb-3">
                          Enter New Password
                        </h4>
                        <div className="form-group d-flex">
                          <input
                            id="viewPassword"
                            className={
                              "form-control" +
                              (ChangePasswordsForm.errors.newPassword &&
                              ChangePasswordsForm.touched.newPassword
                                ? " is-invalid"
                                : "")
                            }
                            type="password"
                            name="newPassword"
                            onChange={(e) =>
                              ChangePasswordsForm.handleChange(e)
                            }
                            value={ChangePasswordsForm.values.newPassword}
                          />
                          <i
                            onClick={() => ViewPassword()}
                            className="fa fa-eye"
                          ></i>
                        </div>
                        <div className="invalid-feedback">
                          {ChangePasswordsForm.errors.newPassword &&
                          ChangePasswordsForm.touched.newPassword
                            ? ChangePasswordsForm.errors.newPassword
                            : null}
                        </div>
                      </div>

                      <div className="form-group mb-4">
                        <h4 className="block-heading mb-3">Confirm Password</h4>
                        <div className="form-group d-flex">
                          <input
                            id="viewPasswords"
                            className={
                              "form-control" +
                              (ChangePasswordsForm.errors.confirmPassword &&
                              ChangePasswordsForm.touched.confirmPassword
                                ? " is-invalid"
                                : "")
                            }
                            type="password"
                            name="confirmPassword"
                            onChange={(e) =>
                              ChangePasswordsForm.handleChange(e)
                            }
                            value={ChangePasswordsForm.values.confirmPassword}
                          />
                          <i
                            onClick={() => ViewPasswords()}
                            className="fa fa-eye"
                          ></i>
                        </div>
                        <div className="invalid-feedback">
                          {ChangePasswordsForm.errors.confirmPassword &&
                          ChangePasswordsForm.touched.confirmPassword
                            ? ChangePasswordsForm.errors.confirmPassword
                            : null}
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="fxt-btn-fill"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-ed"
                      >
                        {loader ? <LoginLoader /> : ""}Change
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          id="delete-ed"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                <p>Do you really want to set your password?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="savebtn-click"
                  onClick={handleChangePassword}
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SetPassword;
